var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from 'aurelia-dependency-injection';
import { BaseModal } from '../../../models/basics/basics.models';
import { DialogClientService } from '../../../services/basics/dialog-client.service';
var GenericConfirmationDialog = /** @class */ (function (_super) {
    __extends(GenericConfirmationDialog, _super);
    function GenericConfirmationDialog(dialogClient) {
        return _super.call(this, dialogClient) || this;
    }
    GenericConfirmationDialog.prototype.activate = function (dataModel) {
        this.dataModel = dataModel;
    };
    GenericConfirmationDialog.prototype.onCancel = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.runCallback(_this.dataModel.onCancel, resolve, reject);
        });
    };
    GenericConfirmationDialog.prototype.onConfirm = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.runCallback(_this.dataModel.onConfirm, resolve, reject);
        });
    };
    GenericConfirmationDialog.prototype.runCallback = function (callback, resolve, reject) {
        var _this = this;
        if (callback) {
            var response = callback();
            if (response instanceof Promise) {
                response.then(function () {
                    _this.hideModal(resolve);
                }).catch(function () {
                    reject();
                });
            }
            else {
                this.hideModal(resolve);
            }
        }
        else {
            this.hideModal(resolve);
        }
    };
    GenericConfirmationDialog = __decorate([
        autoinject,
        __metadata("design:paramtypes", [DialogClientService])
    ], GenericConfirmationDialog);
    return GenericConfirmationDialog;
}(BaseModal));
export { GenericConfirmationDialog };
